import { ModuleType } from '../constants/dataTypes/index';
import { defaultModules } from '../hooks/usePortalModulesState';
/**
 * This function gets the module icon from the extensions/default
 * module array.
 * @param moduleType
 * @param moduleId
 */
export const getModuleIcon = (
  moduleType: ModuleType,
  moduleId: string,
  extensionsSettings: any,
) => {
  if (moduleType === 'module') {
    const module = defaultModules.find(mod => mod.id === moduleId);
    return module?.iconName;
  }

  const extensionConfigEntry = Object.entries(extensionsSettings || {}).find(
    ([extId]) => extId === moduleId,
  );

  if (extensionConfigEntry) {
    return extensionConfigEntry[1].icon;
  }

  return '';
};

/**
 * This function gets the module label from the extensions/default
 * module array.
 * @param moduleType
 * @param moduleId
 */
export const getModuleName = (
  moduleType: ModuleType,
  moduleId: string,
  extensionsSettings: any,
) => {
  if (moduleType === 'module') {
    const module = defaultModules.find(mod => mod.id === moduleId);
    return module?.label;
  }

  const extensionConfigEntry = Object.entries(extensionsSettings || {}).find(
    ([extId]) => extId === moduleId,
  );

  if (extensionConfigEntry) {
    return extensionConfigEntry[1].name;
  }

  return '';
};
